import { assign, createMachine, State } from 'xstate-v4'
import { Interpreter } from 'xstate-v4/lib/interpreter'
import { reportError } from '~/utility/reportError'
import { BookingStatus } from '../status/schema'

/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return --
   TODO: Properly type XState event.data payloads */

export interface PayPalProcessingStateContext {
  bookingId: string
  token: string
  payerId: string
  redirectLocation?: string
  taskId?: string
  error?: any
  status?: BookingStatus
  langCode: string
}

interface PayPalProcessingStateSchema {
  states: {
    triggeringTask: {}
    processing: {}
    responded: {}
    redirection: {}
    error: {}
  }
}

export const payPalProcessingMachine =
  createMachine<PayPalProcessingStateContext>(
    {
      id: 'paypalProcessing',
      initial: 'triggeringTask',
      states: {
        triggeringTask: {
          invoke: {
            src: 'triggerPayPalCheckingTask',
            onDone: [
              {
                target: 'redirection',
                cond: (_, { data }) => !!data.location,
                actions: assign({
                  redirectLocation: (_, { data }) => data.location,
                }),
              },
              {
                target: 'processing',
                actions: assign({
                  taskId: (_, { data }) => data.taskId,
                }),
              },
            ],
            onError: { target: 'error', actions: 'logError' },
          },
        },
        processing: {
          invoke: {
            src: 'loadStatus',
            onDone: {
              target: 'responded',
              actions: assign({
                status: (_, { data }) => data,
              }),
            },
            onError: { target: 'error', actions: 'logError' },
          },
        },
        responded: {
          on: {
            '': [
              {
                target: 'error',
                actions: (ctx) =>
                  reportError(
                    new Error(
                      `Paypal error occurred: ${ctx.status?.result?.error}`,
                    ),
                    { machine: 'paypalProcessing' },
                  ),
                cond: 'isError',
              },
              { target: 'redirection', cond: 'isSuccess' },
            ],
          },
          after: {
            2000: 'processing',
          },
        },
        redirection: {},
        error: {},
      },
    },
    {
      actions: {
        logError: (_, { data }: any) =>
          reportError(data, { machine: 'paypalProcessing' }),
      },
      guards: {
        isSuccess: ({ status }) => (status && status.successful) || false,
        isError: ({ status }) =>
          (status &&
            (status.failed || Boolean(status.result && status.result.error))) ||
          false,
      },
    },
  )

export type PayPalProcessingService = Interpreter<
  PayPalProcessingStateContext,
  PayPalProcessingStateSchema
>
export type PayPalProcessingState = State<PayPalProcessingStateContext>
